export enum UserAuthority {
  CARC_ADMIN = 'CARC_ADMIN',
  CARC_USER = 'CARC_USER',
  LIMITED = 'LIMITED',
  STANDARD = 'STANDARD',
  ADMIN = 'ADMIN'
}

export enum UserType {
  EXTERNAL = 'EXTERNAL',
  NATIVE = 'NATIVE',
  CARC = 'CARC',
}
